import { lazy, Suspense, useEffect } from "react";
import { useConnection } from "wagmi";
import { TopBar, TabBar } from "./layout/TopBar";
import { SigningSheet, Toaster } from "./layout/Overlays";
import { Moment } from "./layout/Moment";
import { useRoute } from "./router";
import { follow, refreshAccount } from "./state/account";
import { startAccountToasts } from "./state/actions";
import { useMarkFeed, useTradingState, useWinFee } from "./state/market";
import { useValuationFeed } from "./state/valuation";
import { useBookKeeper } from "./play/book";
import { Game } from "./views/game/Game";

const Bets = lazy(() => import("./views/bets/Bets").then((m) => ({ default: m.Bets })));
const Cashier = lazy(() => import("./views/cashier/Cashier").then((m) => ({ default: m.Cashier })));

/** What runs once for the page: the markets, the marks, the account, its valuations and the book. */
function useVenue() {
  const trading = useTradingState();
  useMarkFeed(trading.data);
  useWinFee();
  useValuationFeed();
  useBookKeeper();

  // claimable rewards move with the trading state's accumulator
  useEffect(() => {
    if (trading.data) refreshAccount();
  }, [trading.data]);

  const { address, status } = useConnection();
  useEffect(() => {
    if (status === "connected" && address) follow(address);
    else if (status === "disconnected") follow(null);
  }, [address, status]);

  useEffect(() => startAccountToasts(), []);
}

export function App() {
  const route = useRoute();
  useVenue();
  return (
    <div className={`app app-${route.view}`}>
      <TopBar route={route} />
      <Suspense fallback={<div className="page-loading" />}>
        {route.view === "table" && <Game coin={route.coin} />}
        {route.view === "bets" && <Bets />}
        {route.view === "wallet" && <Cashier />}
      </Suspense>
      <TabBar route={route} />
      <Moment />
      <Toaster />
      <SigningSheet />
    </div>
  );
}
